module.exports = __webpack_public_path__ + "img/circleSber.726dbaea.svg";